import { Store } from '../codegen/graphql';

export function isStoreSelected(
    storeId: string,
    selectedStores: string[] | undefined,
): boolean {
    return selectedStores?.includes(storeId) ?? false;
}

export function isEligibleAdvertisingZoneStore(store: Store): boolean {
    if (store.isClosed) {
        return false;
    }

    if (store.priceChangeRestriction) {
        return false;
    }
    return store.productAvailability?.isLive ?? true;
}

export function getEligibleAdvertisingZoneStores(
    advertisingZoneStores: Store[] | null | undefined,
): Store[] {
    if (!advertisingZoneStores) {
        return [];
    }
    return advertisingZoneStores.filter(isEligibleAdvertisingZoneStore);
}

export function getRestrictedAdvertisingZoneStores(
    advertisingZoneStores: Store[] | null | undefined,
): Store[] {
    if (!advertisingZoneStores) {
        return [];
    }
    return advertisingZoneStores.filter(store =>
        Boolean(store.priceChangeRestriction),
    );
}

export function getEligibleAdvertisingZoneStoreIds(
    advertisingZoneStores: Store[] | null | undefined,
): string[] {
    return getEligibleAdvertisingZoneStores(advertisingZoneStores).map(
        store => store.id,
    );
}

export function filterStoreIdsToEligibleSet(
    storeIds: string[] | null | undefined,
    eligibleStores: Store[],
): string[] {
    if (!storeIds || storeIds.length === 0) {
        return [];
    }
    const eligibleIds = new Set(eligibleStores.map(store => store.id));
    return storeIds.filter(id => eligibleIds.has(id));
}

export type ApplicableTo = 'zone' | 'store';

export function parseApplicableTo(value: string): ApplicableTo | null {
    if (value === 'zone') {
        return 'zone';
    }
    if (value === 'store') {
        return 'store';
    }
    return null;
}

export function getDefaultApplicableTo(
    hasEligibleZoneStores: boolean,
): ApplicableTo {
    if (hasEligibleZoneStores) {
        return 'zone';
    }
    return 'store';
}
